import styled from 'styled-components'
import { RADOM_COLORS } from '../util/Constants'

export const DesignerPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 460px;
  width: 460px;
  min-width: 420px;
  height: 100vh;
  font-size: 14px;
  background: ${RADOM_COLORS.WHITE};
  border-right: 1px solid rgba(227, 229, 240, 0.9);
  z-index: 2;

  @media (max-width: 980px) {
    width: 100%;
    min-width: 0;
  }
`

export const DesignerHeader = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 30px;
  background: ${RADOM_COLORS.WHITE};
  border-bottom: 1px solid ${RADOM_COLORS.GRAY_MED};
  z-index: 3;
`

export const DesignerHeaderIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
`

export const DesignerHeaderCopy = styled.div`
  display: grid;
  gap: 5px;
  min-width: 0;
`

export const DesignerKicker = styled.div`
  display: none;
`

export const DesignerTitle = styled.h1`
  margin: 0;
  color: ${RADOM_COLORS.BLACK};
  font-size: 18px;
  font-weight: 400;
  line-height: 1.2;
`

export const DesignerDescription = styled.p`
  display: none;
`

export const DesignerFormBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 24px 28px 28px;
`

export const DesignerFormStack = styled.div`
  display: grid;
  gap: 22px;
`

export const DesignerSection = styled.section`
  display: grid;
  gap: 14px;

  & + & {
    padding-top: 22px;
    border-top: 1px solid rgba(227, 229, 240, 0.85);
  }
`

export const DesignerSectionHeader = styled.div`
  display: grid;
  gap: 5px;
`

export const DesignerSectionTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  color: ${RADOM_COLORS.BLACK};
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
`

export const DesignerSectionDescription = styled.p`
  display: none;
`

export const DesignerSetting = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
`

export const DesignerSettingText = styled.div`
  display: grid;
  gap: 4px;
  min-width: 0;
`

export const DesignerSettingTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${RADOM_COLORS.BLACK};
  font-size: 14px;
  font-weight: 500;
`

export const DesignerSettingDescription = styled.div`
  display: none;
`

export const DesignerInlineGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`

export const DesignerFooter = styled.div`
  flex-shrink: 0;
  padding: 16px 28px 20px;
  background: ${RADOM_COLORS.WHITE};
  border-top: 1px solid rgba(227, 229, 240, 0.85);
  box-shadow: 0 -10px 24px rgba(40, 40, 40, 0.035);
  z-index: 2;

  button:hover {
    opacity: 1;
    transform: translateY(-1px) scale(1.005);
    box-shadow: 0 10px 22px rgba(41, 99, 255, 0.22);
  }

  button:active {
    transform: translateY(0) scale(0.995);
    opacity: 0.96;
  }
`
